import { render, staticRenderFns } from "./Item1.vue?vue&type=template&id=f5184990&scoped=true&"
import script from "./Item1.vue?vue&type=script&lang=js&"
export * from "./Item1.vue?vue&type=script&lang=js&"
import style0 from "./Item1.vue?vue&type=style&index=0&id=f5184990&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5184990",
  null
  
)

export default component.exports